<template>
  <div>
    <div class="d-flex flex-column align-items-stretch">
      <div class="d-flex justify-content-between">
        <!-- <div class="mb-1 me-1 col-md-2">
          <select class="form-control" v-model="selectedSorting">
            <option v-for="so in sortOptions" :value="so">{{ so.value }}</option>
          </select>
        </div> -->
        <div class="">
          <button class="btn btn-sm bg-gradient-secondary mb-0 py-1" @click="showFilters">فیلترها</button>
        </div>
      </div>
      <div class="table-responsive p-0">
        <table class="table table-striped table-sm table-styled">
          <thead id="tLTH">
            <tr>
              <th scope="col">#</th>
              <th scope="col">عنوان</th>
              <th scope="col">عنوان والد</th>
              <th scope="col">تعداد تیکت‌ها</th>
              <th scope="col">زمان صرف شده</th>
              <th scope="col">ثبت تا رسیدگی</th>
              <th scope="col">در انتظار پاسخ مشتری</th>
              <th scope="col">ثبت تا پاسخ</th>
            </tr>
          </thead>
          <tbody>
            <tr></tr>
            <tr v-for="(r, index) in resultsList">
              <td>
                <span class="pe-1">
                  {{ index + (pageIndex * pageSize) + 1 }}
                </span>
              </td>
              <td>{{ r.title }}</td>
              <td>{{ r.parentTitle }}</td>
              <td>{{ r.ticketsCount }}</td>
              <td>{{ $filters.minutesToTimeString(r.totalTimeSpent) }}</td>
              <td>{{ $filters.minutesToTimeString(r.timeBeforeFirstCompanyChange) }}</td>
              <td>{{ $filters.minutesToTimeString(r.timeAwaitingCustomerResponse) }}</td>
              <td>{{ $filters.minutesToTimeString(r.timeTakenToAnswer) }}</td>
            </tr>
          </tbody>
        </table>
        <Pagination :totalRecordCount="resultsList?.[0]?.totalRecordsCount ?? 0" :listPageSize="[10, 15, 20, 30, 50, 100]"
          :pageSize="pageSize" :pageIndex="pageIndex" @change-callback="updatePagination" />
        <hr class="horizontal dark" />
        <button class="btn btn-sm bg-gradient-secondary mb-0 py-1" @click="showFilters">فیلترها</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    emits: ['paginationUpdate', 'sortingUpdate', 'showFilters'],
    props: {
      resultsList: {
        type: Array
      },
      selectedSorting: {
        type: Object
      },
      pageSize: {
        type: Number
      },
      pageIndex: {
        type: Number
      }
    },
    data() {
      return {
        sortOptions: [
          { key: 0, value: 'قدیمی ترین تیکت' },
          { key: 1, value: 'جدیدترین تیکت' },
        ],
      }
    },
    watch: {
      selectedSorting() {
        this.$emit('sortingUpdate', this.selectedSorting);
      }
    },
    methods: {
      updatePagination(pageNumber, pageSize) {
        this.$emit('paginationUpdate', pageNumber - 1, pageSize);

        window.scrollTo(0, 0);
      },
      showFilters() {
        this.$emit('showFilters');
      }
    },
    mounted() {
      window.scrollTo(0, 0);
    },
    beforeUnmount() {
    }
  }
</script>